
export const LICENSE_CODES =
{
  FEDERAL: {
    //required
    DCA: 'class',
    DCB: 'restrictions',
    DCD: 'endorsements',
    DBA: 'expiration',
    DCS: 'lastName',
    DAC: 'firstName',
    DAD: 'middleName',
    DBD: 'issued',
    DBB: 'dob',
    DBC: 'gender',
    DAY: 'eyeColor',
    DAU: 'height',
    DAG: 'street',
    DAI: 'city',
    DAJ: 'state',
    DAK: 'zip',
    DAQ: 'licenseNumber',
    DCF: 'documentDiscriminator',
    DCG: 'country',
    DDE: 'lastNameTruncated',
    DDF: 'firstNameTruncated',
    DDG: 'middleNameTruncated',
    //optional
    DAH: 'secondaryStreet',
    DAZ: 'hairColor',
    DCI: 'pob',
    DCJ: 'auditInformation',
    DCK: 'inventoryControlNumber',
    DBN: 'lastNameAlias',
    DBG: 'firstNameAlias',
    DBS: 'suffixAlias',
    DCU: 'nameSuffix',
    DCE: 'weightRange',
    DCL: 'race',
    DCM: 'standardVehicleClassification',
    DCN: 'standardEndorsementCode',
    DCO: 'standardRestrictionCode',
    DCP: 'vehicleClassificationDescription',
    DCQ: 'endorsementCodeDescription',
    DCR: 'restrictionCodeDescription',
    DDA: 'complianceType',
    //Dates are formatted as MMDDCCYY for US and CCYYMMDD for Canada
    DDB: 'cardRevisionDate',
    DDC: 'hazmatExpiration',
    DDD: 'limitedDurationDocumentStatus',
    DAW: 'weight',
    DAX: 'weightKgs',
    DDH: 'under18Until',
    DDI: 'under19Until',
    DDJ: 'under21Until',
    DDK: 'organDonor',
    DDL: 'veteran',
    //FL - full name as last,first, middle initial - with a space between the 
    DAA: 'fullName',
    //NY - first,middle - may only contain the first name if no middle name is listed
    DCT: "firstMiddle"
  },
}